import { ErrorCode } from 'react-dropzone'

import { getBytesFromMegabytes } from '../../../../utils/file'
import { FILE_MAX_SIZE, FILE_MIN_SIZE } from '../../File.constants'

export const FILE_UPLOAD_DROPZONE_OPTIONS = {
  maxSize: getBytesFromMegabytes(FILE_MAX_SIZE),
  minSize: FILE_MIN_SIZE,
  multiple: true,
  noClick: true,
}

export const REACT_DROPZONE_ERROR_INVALID_TYPE = ErrorCode.FileInvalidType

export const REACT_DROPZONE_ERROR_TOO_LARGE = ErrorCode.FileTooLarge

export const REACT_DROPZONE_ERROR_TOO_MANY = ErrorCode.TooManyFiles

export const REACT_DROPZONE_ERROR_TOO_SMALL = ErrorCode.FileTooSmall

export const REACT_DROPZONE_ERROR_CODES = {
  [REACT_DROPZONE_ERROR_INVALID_TYPE]: 'Error.SubmittedFileIsWrongTypeKey',
  [REACT_DROPZONE_ERROR_TOO_LARGE]: 'Error.SubmittedFileIsTooLarge',
  [REACT_DROPZONE_ERROR_TOO_SMALL]: 'Error.SubmittedFileIsEmptyKey',
}
